export function Key (pEditor)
{
  let currentKeyDown = null,
      htmlCodeKeyNext = -1,
      isRangeKeyUp,
      undoKeyPressedTM = null,
      isEnterKeyDownThrottle = false,
      snapshotSelection =
      {
        anchorNode: null,
        anchorOffset: null,
        focusNode: null,
        focusOffset: null,
        isCollapsed: null,
        rangeCount: null
      };


  this.reInit = () =>
  {
    undoKeyPressedTM = null;
  };


  this.keyDown = (e) =>
  {
    e = e || window.event;

    if (!e || !pEditor.pThis.isObjValid || pEditor.pThis.isObjValid < 2)
    {
      return false;
    }

    if (pEditor.isEditorInHeader)
    {
      pEditor.layer.helpers.normalizeAbsElement();
    }

    let onlyKey = !e.ctrlKey && !e.altKey && !e.shiftKey,
        onlyCtrlKey = e.ctrlKey && !e.altKey && !e.shiftKey,
        onlyShiftKey = e.shiftKey && !e.ctrlKey && !e.altKey,
        key = (BEditor.browser.isIE) ? e.keyCode : e.which;

    if (!currentKeyDown)
    {
      currentKeyDown = {};
      currentKeyDown.isDown = false;
    }

    pEditor.copyPaste.hideAutoCleaningMessage();

    currentKeyDown.keyCode = key;
    currentKeyDown.ctrlKey = e.ctrlKey;
    currentKeyDown.altKey = e.altKey;
    currentKeyDown.shiftKey = e.shiftKey;
    currentKeyDown.onlyCtrlKey = onlyCtrlKey;
    currentKeyDown.onlyShiftKey = onlyShiftKey;

    if (key === 37 || key === 39)
    {
      snapshotSelection =
      {
        anchorNode: pEditor.frameSize.savedSelection.anchorNode,
        anchorOffset: pEditor.frameSize.savedSelection.anchorOffset,
        focusNode: pEditor.frameSize.savedSelection.focusNode,
        focusOffset: pEditor.frameSize.savedSelection.focusOffset,
        isCollapsed: pEditor.frameSize.savedSelection.isCollapsed,
        rangeCount: pEditor.frameSize.savedSelection.rangeCount
      }
    }

    if (onlyCtrlKey && (key === 90 || key === 122) && pEditor.undoRedo.queryExecUndoRedo(null, 'undo'))
    {
      pEditor.undoRedo.execUndoRedo(null, 'undo');
      return BEditor.domHandlers.stopEvent(e);
    }

    if (BEditor.browser.isIE)
    {
      pEditor.anchor.currentAnchorIndex = null;
    }

    if (onlyCtrlKey && key === 32)
    {
      pEditor.style.cleaner.cleanupHTML();
      return BEditor.domHandlers.stopEvent(e);
    }

    if (key === 13)
    {
      let isDefault = false;

      if (onlyKey || onlyShiftKey)
      {
        if (!isEnterKeyDownThrottle)
        {
          if (onlyKey)
          {
            isDefault = pEditor.helpers.dom.breakBlockNode();
          }
          else if (onlyShiftKey)
          {
            pEditor.helpers.dom.insertBR();
          }

          isEnterKeyDownThrottle = true;
          setTimeout(() => isEnterKeyDownThrottle = false, 100);
        }

        return (isDefault ? true : BEditor.domHandlers.stopEvent(e));
      }
    }

    if (onlyKey && (key === 8 || key === 46) && BEditor.browser.isWebKit)
    {
      let isStopEvent = pEditor.helpers.dom.deleteEmptyBlockNode((key === 8));

      if (!pEditor.helpers.fixers.isWebKitSpansCollected)
      {
        pEditor.helpers.fixers.fixWebKitSpan();
      }

      if (isStopEvent)
      {
        return BEditor.domHandlers.stopEvent(e);
      }
    }

    if (((onlyCtrlKey && key === 86) || (onlyShiftKey && key === 45)) && !BEditor.browser.isIE)
    {
      pEditor.contentChecker.clearExcludeWordCheckDo();
      setTimeout(pEditor.contentChecker.checkContentChanged, 10);
    }
    else if (!BEditor.browser.isIE)
    {
      pEditor.contentChecker.setExcludeWordCheck();
    }

    if (e.altKey && e.ctrlKey && e.shiftKey)
    {
      if (key === 72)
      {
        htmlCodeKeyNext = 72;
      }

      if (key === htmlCodeKeyNext)
      {
        if (key === 72)
        {
          htmlCodeKeyNext = 84;
        }
        else if (key === 84)
        {
          htmlCodeKeyNext = 77;
        }
        else if (key === 77)
        {
          htmlCodeKeyNext = 76;
        }
        else if (key === 76)
        {
          htmlCodeKeyNext = 72;
          pEditor.helpers.htmlWin.create();
        }

        if (BEditor.browser.isIE)
        {
          e.returnValue = false;
        }
        else
        {
          currentKeyDown.isDown = true;
          return false;
        }
      }
    }

    if (BEditor.browser.isIE)
    {
      e.returnValue = true;
    }
    else
    {
      currentKeyDown.isDown = true;
      return true;
    }

    currentKeyDown.isDown = true;

    function getIsRealNextSibling (node)
    {
      node = node.nextSibling;

      while (node && node.type !== 3)
      {
        if (node.nodeValue !== '')
        {
          return true;
        }

        node = node.nextSibling;
      }
    }

    return false;
  };


  this.keyUp = (e) =>
  {
    e = e || window.event;

    if (!e || !pEditor.pThis.isObjValid || pEditor.pThis.isObjValid < 2)
    {
      return false;
    }

    isRangeKeyUp = true;
    currentKeyDown = null;

    let currentSelection,
        onlyKey = !e.ctrlKey && !e.altKey && !e.shiftKey,
        onlyCtrlKey = e.ctrlKey && !e.altKey && !e.shiftKey,
        onlyShiftKey = e.shiftKey && !e.ctrlKey && !e.altKey,
        key = (BEditor.browser.isIE) ? e.keyCode : e.which;

    pEditor.range.checkSelection();

    if ((onlyKey || onlyShiftKey) && key === 13)
    {
      return BEditor.domHandlers.stopEvent(e);
    }

    if (onlyKey && (key === 8 || key === 46) && BEditor.browser.isWebKit)
    {
      if (pEditor.helpers.fixers.fixWebKitSpanTM) clearTimeout(pEditor.helpers.fixers.fixWebKitSpanTM);
      pEditor.helpers.fixers.fixWebKitSpanTM = setTimeout(pEditor.helpers.fixers.fixWebKitSpan, 17);
    }

    if (onlyKey && (key === 37 || key === 39) && (BEditor.browser.isGecko || BEditor.browser.isIE))
    {
      currentSelection = pEditor.iFrame.getSelection();

      if (currentSelection && snapshotSelection.isCollapsed === currentSelection.isCollapsed && snapshotSelection.anchorNode === currentSelection.anchorNode && snapshotSelection.anchorOffset === currentSelection.anchorOffset && snapshotSelection.rangeCount === currentSelection.rangeCount)
      {
        pEditor.helpers.fixers.fixGeckoIETable(key);
      }
    }

    pEditor.undoRedo.isStopSaveUndo = false;

    if (key === 8 || key === 9 || key === 13 || (key >= 33 && key <= 40) || key === 66 || key === 73 || key === 85)
    {
      pEditor.pToolbar.refreshState();
    }

    pEditor.helpers.dom.removeLastBR();

    if ((e.ctrlKey || e.altKey || key <= 32 || key === 126) && !pEditor.contentChecker.isPasteEvent)
    {
      if (undoKeyPressedTM) clearTimeout(undoKeyPressedTM);

      if (pEditor.undoRedo.isUndoKeyPressed !== key)
      {
        pEditor.undoRedo.isUndoKeyPressed = key;
        pEditor.undoRedo.saveUndo();
      }
    }
    else
    {
      if (undoKeyPressedTM) clearTimeout(undoKeyPressedTM);
      pEditor.undoRedo.isUndoKeyPressed = false;
      undoKeyPressedTM = setTimeout(pEditor.undoRedo.setPressedKeyInterval, 1037);
    }

    pEditor.extRefreshState();
    setTimeout(pEditor.range.checkSelection, 17);

    if (BEditor.browser.isIE)
    {
      e.returnValue = true;
    }
    else
    {
      return true;
    }
  };


  this.keyPress = (e) =>
  {
    e = e || window.event;

    if (!e || !pEditor.pThis.isObjValid || pEditor.pThis.isObjValid < 2)
    {
      return false;
    }

    const key = (BEditor.browser.isIE) ? e.keyCode : e.which;

    if (!e.altKey && e.shiftKey && !e.ctrlKey && key === 13)
    {

    }
  };


  Object.defineProperty(this, 'isRangeKeyUp', { get: () => isRangeKeyUp, set: v => { isRangeKeyUp = v }});
  Object.defineProperty(this, 'undoKeyPressedTM', { get: () => undoKeyPressedTM, set: v => { undoKeyPressedTM = v }});
}